import { z } from 'zod'

import { m } from '@maestro/commerce-blocks/schemas/helpers'
import { parseCartImportText } from '@maestro/commerce-blocks/utils/cart-import-export.utils'

export const importProductsFormSchema = z.object({
  items: z
    .string()
    .min(1, m('items.required'))
    .superRefine((value, ctx) => {
      const { invalidLines } = parseCartImportText(value)

      if (invalidLines.length > 0) {
        ctx.addIssue({
          code: 'custom',
          message: m('items.invalid-lines', {
            lines: invalidLines.join(', '),
          }),
        })
      }
    }),
})
